export default __webpack_public_path__ + "static/media/ca.ef61af62.svg";